<app-tank-setup-swap-assign-form
  [uniqueId]="uniqueId"
  [isAssign]="isAssign"
  [deviceId]="deviceId"
  [contextDeviceId]="contextDeviceId"
  [isHostAssignment]="isHostAssignment"
  (cancelled)="onCancelled()"
  (swapped)="onSwapped()"
  ></app-tank-setup-swap-assign-form>
